/**
 * Master kill switch for the Dual CPU flash node (CONF-210).
 *
 * Set to false to pull the feature in every environment, in one line:
 * - Nobody is offered the Flash Node Model control (classic
 *   FlashNodeModelToggle and the V2 storage-set picker both hide it), and a
 *   quote that already carries the node shows it locked with the reason
 *   "Dual CPU flash nodes are not enabled in this release".
 * - A persisted `afaNodeModel: 'dualCpu'` is inert: the eligibility check in
 *   src/domain/rules/dualCpuRules.ts reads this constant and every consumer
 *   resolves the node through it, so such a quote prices, sizes and reports
 *   as the single-CPU VCH-5000-F1N while this is off.
 * - The value itself is left in place (R13 does not rewrite it while the
 *   feature is off), so flipping the switch back on restores every saved
 *   Dual CPU quote, including ones re-saved during the rollback.
 *
 * Kept as a constant rather than an env var deliberately, matching
 * CCI_FEATURE_ENABLED (src/utils/shouldUseCciPath.js), so the revert is a
 * one-line commit. Three tests fail on a flip and are the ones to update with
 * it: the tripwire in dualCpuFlashFeature.test.js, "AIC offers the Dual CPU
 * flash node" in dualCpuRules.test.ts, and productOffering.real.test.js,
 * which will then need VCH-5500-F1N added to its pinned unreachable list.
 *
 * See docs/superpowers/specs/2026-09-25-conf-210-dual-cpu-flash-node-design.md.
 */
export const DUAL_CPU_FLASH_FEATURE_ENABLED = true;
